import { difference } from 'lodash'

import { DEFAULT_LOCALE } from './containers/app/constants'
import { messages as enTranslationMessages } from './zustand/language/chunks/en'

export const appLocales = [
  'bg',
  'hr',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fr',
  'hu',
  'it',
  'nl',
  'no',
  'pl',
  'pt-br',
  'tr',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv'
]

export const normalizeTranslationMessages = (messages) => {
  if (!messages || typeof messages !== 'object') {
    return {}
  }

  if (!messages.default || typeof messages.default !== 'object') {
    return messages
  }

  return Object.entries(messages).reduce(
    (normalizedMessages, [key, value]) => {
      if (key !== 'default') {
        normalizedMessages[key] = value
      }

      return normalizedMessages
    },
    { ...messages.default }
  )
}

const normalizedEnTranslationMessages = normalizeTranslationMessages(
  enTranslationMessages
)

export const formatTranslationMessages = (locale, messages) => {
  const normalizedMessages = normalizeTranslationMessages(messages)
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(
          DEFAULT_LOCALE,
          normalizedEnTranslationMessages
        )
      : {}

  return Object.keys(normalizedMessages).reduce((formattedMessages, key) => {
    let message = normalizedMessages[key]
    if (!message && locale !== DEFAULT_LOCALE) {
      message = defaultFormattedMessages[key]
    }

    // eslint-disable-next-line no-param-reassign
    formattedMessages[key] = message

    return formattedMessages
  }, {})
}

export const fillGaps = (formattedMessages) => {
  const diffKeys = difference(
    Object.keys(normalizedEnTranslationMessages),
    Object.keys(formattedMessages)
  )
  diffKeys.forEach((missingKey) => {
    // eslint-disable-next-line no-param-reassign
    formattedMessages[missingKey] = normalizedEnTranslationMessages[missingKey]
  })
  return formattedMessages
}
